import React from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import ReactPaginate from "react-paginate";

import "./style/Pagination.css";
type TEventPaginate = {
	selected: number;
};
interface IReactPagination {
	handlePageClick: (event: TEventPaginate) => void;
	pageCount: number;
}
function ReactPagination({ handlePageClick, pageCount }: IReactPagination) {
	return (
		<div className="paginations-container flex-m gap-4">
			<ReactPaginate
				onPageChange={handlePageClick}
				pageRangeDisplayed={1}
				marginPagesDisplayed={3}
				pageCount={pageCount}
				previousLabel={<FiChevronLeft />}
				nextLabel={<FiChevronRight />}
				pageClassName="page-item"
				pageLinkClassName="page-link"
				previousClassName="page-item"
				previousLinkClassName="page-link"
				nextClassName="page-item"
				nextLinkClassName="page-link"
				breakLabel="..."
				breakClassName="page-item"
				breakLinkClassName="page-link"
				containerClassName="pagination"
				activeClassName="active"
			/>
		</div>
	);
}

export default ReactPagination;
